import React from "react";
import { Box, Typography, Container, Link } from "@mui/material";

function Terms() {
  return (
    <Container maxWidth="md" sx={{ py: 5, mt:{xs:'5vh', md:'15vh'} }}>
      {/* Sayfa Başlığı */}
      <Typography variant="h4" textAlign="center" gutterBottom>
        Ostoehdot
      </Typography>

      {/* 1️⃣ Yleiset ehdot */}
      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          Yleiset ehdot
        </Typography>
        <Typography>
        <p>Ostoehdot astuvat voimaan tilauksen teon yhteydessä, kun vahvistat tilauksesi kassalla. 
        Automaattinen tilausvahvistus lähetetään tilauksen teon yhteydessä antamaasi sähköpostiosoitteeseen. 
        ehankki.fi toimii M2 tähti Oy toiminimen alla. 
        Ostoehdot on laatinut M2 tähti Oy  Y-tunnus: 3271482-5, ja ostosopimus allekirjoitetaan M2 tähtin kanssa.</p>
        <p>
          Tilauksesi lähetetään Helsingin varastosta  muutokset ja lisäykset tulee tehdä ennen tilauksen käsittelyä 
          ja lähetystä meiltä. Jos huomaat virheen tilauksessasi, on tämän vuoksi tärkeää, että otat asiakaspalveluumme yhteyttä 
          välittömästi muuttaaksesi tilauksesi tai antamiasi tietoja mahdollisimman pian.
          Huomioithan, että laskulle otetun tilauksen toimitusosoitetta ei voi 
          muuttaa jälkikäteen ilman erillistä sopimusta. Saat lisätietoja asiakaspalvelustamme.
        </p>
        <p>
          Ilmeisten virheiden (kuten väärä hinta, kirjoitusvirhe, jne.) kohdalla, 
          pidätämme oikeuden korjata virheen jälkikäteen. Jos et ole tyytyväinen korjaukseemme, 
          olet luonnollisesti oikeutettu perumaan tilauksesi. 
          Pidätämme oikeuden myös keskeyttää tilauksen jos jokin tilauksen tuote on loppu varastolta tai teknisen vian vuoksi.
        </p>
        <p>
          Pidätämme oikeuden kirjoitusvirheisiin, virheelliseen tietoon sekä kaikkiin 
          valikoimassamme esiintyvien tuotteiden ja palveluiden määrittelyvirheisiin. 
          Kuvamateriaali sivuillamme toimii tuotteiden havainnollistamista varten eikä 
          Ehankki.fi voi taata, että kuva täysin vastaa tuotteen ulkonäköä ja luontoa.
        </p>
        </Typography>
      </Box>

      {/* 2️⃣ Hinnat */}
      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          Hinnat
        </Typography>
        <Typography>
        <p>Kaikki hinnat verkkokaupassa ovat esitetty euroina (€) ja ne sisältävät arvonlisäveron ja muut verot. 
        Kaikki verkkokauppamme hinnat eivät sisällä toimituskuluja, vain märitelty tilaukset toimitetaan ilman toimituskuluja. 
        Tuotteiden hinnat ovat tuotteen tilauspäivänä voimassa olevan hinnaston mukaisia ja niitä päivitetään säännöllisesti. 
        Pidätämme oikeuden kirjoitusvirheisiin sekä hintamuutoksiin ilman ilmoitusta. 
        Pidätämme oikeuden perua tilauksen tuotteen hinnoitteluvirheestä johtuneen väärän hinnan vuoksi.</p>
        </Typography>
      </Box>

      {/* 3️⃣ Maksutavat */}
      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          Maksutavat
        </Typography>
        <Typography>
        <p>Yhteistyössä Klarnan kanssa tarjoamamme maksutavat ovat pankki- tai luottokortti, lasku, maksu pankkitililtä ja osamaksu.
        Voit tarkistaa ajantasaiset ehdot Klarnalta. Lue lisää täältä: https://www.klarna.com/fi/ehdot/</p>
        </Typography>
      </Box>

      {/* 4️⃣ Peruutus ja palautusoikeus */}
      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          Peruutus ja palautusoikeus
        </Typography>
        <Typography>
         
            Mikäli tuote on kadonnut kuljetuksen aikana, vioittunut tai asiakkaalle on toimitettu väärä tuote, tulee asiakkaan ilmoittaa virheestä välittömästi 
            sähköpostiosoitteeseen info@ehankki.fi  . Ilmoitus virheellisestä toimituksesta tai viallisesta tuotteesta on tehtävä eHankki 
            Kaluste :lle samana päivänä kuin tuote on vastaanotettu. Myöhässä tehtyjä reklamaatioita emme valitettavasti voi ottaa käsittelyyn..<p/>
       
            Vaihto- ja palautusehdot<p/>
            Jos haluat vaihtaa tai palauttaa virheellisen tuotteen, ota ensin yhteys M2 Tähti Oy :n asiakaspalveluun: info@ehankki.fi. 
            Asiakkaalle lähetetään sähköpostitse palautusohjeet.
            Tuotteita ei saa palauttaa sopimatta siitä ensin asiakaspalvelumme kanssa. Emme lunasta palautuksia, joista ei ole sovittu ennakolta 
            asiakaspalvelumme kanssa. Hygieniatuotteilla kuten tyynyillä, peitoilla, matolla ja petauspatjoilla ei ole vaihto- eikä palautusoikeutta. 
            Sama koskee myös erikoismittaisia ja kaikkia ns. mittatilaustuotteita.
            Liitä palautuksen mukaan seuraavat tiedot:
            Kuittisi, nimesi, osoitteesi ja puhelinnumerosi
            ,sähköpostiosoitteesi ja pankkitilinumerosi.
              

            <p/>Palautusosoite: M2 TÄHTI Oy , Niittyläntie 3 , 00620 Helsinki eHankki Kaluste Noutopiste.
            Emme vastaanota palautuksia yli 14 vrk kuluttua tilauksesta
        
            <p/>Voit palauttaa ostamasi tuotteen itse, jolloin sinun ei tarvitse maksaa toimitusmaksua.
            Mikäli pyydät meitä noutamaan tuotteen uudelleen, toimitusmaksu lasketaan ehtojen mukaan, kuten matkan pituus, mistä 
            kerroksesta tuote voidaan noutaa, ja loppusumma palautetaan tämän toimitusmaksun vähentämisen jälkeen.
            Sohvamaisten tuotteiden osalta, jos niitä ei palauteta samana päivänä, pesumaksu lasketaan ja vähennetään maksetusta hinnasta.
            Käytön aikana sattuneista vaurioista (käyttöjäljet, tahrat jne.) pesu- ja korjausmaksu lasketaan lisämaksuna ja vähennetään maksetusta hinnasta.
              </Typography>
      </Box>

      {/* 6️⃣ Yhteystiedot */}
      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          Yhteystiedot
        </Typography>
        <Typography>
          <b>M2 Tähti Oy</b> <br />
          Ehankki <br />
          Niittyläntie 3, 00620 Helsinki <br />
          Puhelin: <Link href="tel:0413124969">041 312 4969</Link> <br />
          Sähköposti: <Link href="mailto:info@ehankki.fi">info@ehankki.fi</Link>
        </Typography>
      </Box>

      {/* Footer */}
      <Box textAlign="center" mt={5} py={2} sx={{ backgroundColor: "#f5f5f5" }}>
        <Typography variant="body2">&copy; 2024 M2 Tähti Oy. Kaikki oikeudet pidätetään.</Typography>
      </Box>
    </Container>
  );
}
export default Terms;
